import React, { useState, useEffect } from "react";
import { Alert, Box } from "@mui/material";
import Viewer from "../components/Viewer";
import { Clients } from "../graphql/querys/clients";
import { useLocation } from "react-router-dom";

export default function ClientsScreen() {
	const location = useLocation();
	const [error, setError] = useState(null);

	// Check for error in location state
	useEffect(() => {
		if (location.state && location.state.error) {
			setError(location.state.error);
			// Clear the error after displaying it
			window.history.replaceState({}, document.title);
		}
	}, [location]);

	return (
		<>
			{error && (
				<Box sx={{ m: 2 }}>
					<Alert severity="error" onClose={() => setError(null)}>
						{error}
					</Alert>
				</Box>
			)}
			<Viewer viewerInfo="clients" viewerQueryAll={Clients}></Viewer>
		</>
	);
}
